import styles from './buy-mobile-preview.module.scss';
import PreviewWrapper from '@components/shared/header/nav-previews/preview-wrapper/preview-wrapper';
import Link from 'next/link';

import { Themes } from '@layouts/main-layout/themes.enum';
import { BuyPreviewState } from '../../../nav-state/buy-preview.state';
import { ReactSVG } from 'react-svg';
import { useTranslations } from 'next-intl';
import { cloneDeep } from 'lodash';

type BuyMobilePreviewProps = {
  theme: Themes;
  onMenuClicked?: () => void
};

const BuyMobilePreview = ({ theme, onMenuClicked }: BuyMobilePreviewProps) => {
  const t = useTranslations();
  const copyBuyPreviewState = cloneDeep(BuyPreviewState);
  const buyCards = copyBuyPreviewState.cards.sort((a, b) => a.footerOrder - b.footerOrder);
  const cards = buyCards;

  const themedClasses = (classes: string) => `${classes} ${styles[theme]}`;
  const arrowIconSrc = '/layout-images/header/icons/chevron-right.svg';

  return (
    <div className={themedClasses(styles.cards)}>
      {cards.map((card, key) => (
        <div key={key} className={styles.cards__default} style={{ minWidth: card.colWidth }}>
          <Link scroll={false} href={card.href} passHref legacyBehavior>
            <div className={styles.cards__title__wr} onClick={onMenuClicked}>
              <ReactSVG style={{ maxWidth: '32px', maxHeight: '32px' }} src={card.iconSrc} />
              <h4 className={styles.cards__title}>{t(card.title)}</h4>
              <ReactSVG style={{ maxWidth: '16px', maxHeight: '16px' }} src={arrowIconSrc} />
            </div>
          </Link>

          <div className={styles.cards__body}>
            {card.links.map((link, key) => (
              <Link key={key} href={link.href} legacyBehavior>
                <a onClick={onMenuClicked} className={themedClasses(styles.cards__link)}>
                  <span>{t(link.title)}</span>
                </a>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BuyMobilePreview;
